import { ng } from '@uirouter/angularjs/lib/angular';
import { $q } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../app.common/modules/common/services/notification.service';
import { RetailerService } from '../api/retailer.service';
import { IStore } from './models/store.interface';
import { PublisherSettingsService } from './publisher-settings.service';

class PublisherSettingsComponent {
    public static $inject = [
        '$translate',
        'retailerService',
        'publisherSettingsService',
        'notificationService',
        '$uibModal'
    ];

    public form: ng.IFormController;
    public logoImage: string;
    public businessName: string;
    public waiting: boolean = false;
    public maxSessionDuration: number = 1440;
    public maxPeriodDuration: number = 168;
    public maxLimit: number = 10079;
    public showLogoPopup: boolean = false;

    private minSize = {
        w: 210,
        h: 210
    };
    private imageChanged: boolean = false;
    private originalStore: IStore;

    constructor(
        private $translate: angular.translate.ITranslateService,
        private retailerService: RetailerService,
        private publisherSettingsService: PublisherSettingsService,
        private notificationService: NotificationService,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
    }

    public async $onInit() {
        this.waiting = true;
        try {
            await this.fetchFormData();
        } catch (e) {
            return;
        } finally {
            this.waiting = false;
        }
    }

    public async addImage() {
        this.showLogoPopup = false;
        if (this.waiting) {
            return;
        }
        try {
            const image = await this.$uibModal.open({
                component: 'jispPayAvatar',
                resolve: {
                    avatarId: () => this.logoImage != null,
                    title: () => this.$translate.instant('store_photo'),
                    sizeText: () => this.$translate.instant('store_photo_min_size_hint', {width: 210, height: 210}),
                    getUrl: () => {
                        if (this.imageChanged) {
                            return this.logoImage;
                        } else if (this.originalStore.IconID) {
                            return this.retailerService.getStoreLogoUrl(this.originalStore.IconID);
                        } else {
                            return null;
                        }
                    },
                    imageSize: () => this.minSize
                },
                backdrop: 'static'
            }).result;
            if (image) {
                this.logoImage = image;
                this.imageChanged = true;
                this.form.$setDirty();
            }
        } catch (error) {
            return;
        }
    }

    public async removeLogo() {
        this.showLogoPopup = false;
        this.logoImage = null;
        this.imageChanged = true;
        this.form.$setDirty();
    }

    public async save() {
        if (this.waiting) {
            return;
        }
        if (!this.isFormValid()) {
            this.form.$$controls.map((control) => control.$setDirty());
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const requests = [];
            if (this.originalStore.Name !== this.businessName) {
                requests.push(this.publisherSettingsService.savePublisherName(this.originalStore.ID, this.businessName));
            }
            if (this.imageChanged) {
                if (this.originalStore.IconID) {
                    await this.publisherSettingsService.deleteLogo(this.originalStore.IconID);
                }
                if (this.logoImage) {
                    requests.push(this.publisherSettingsService.uploadImage(this.originalStore.ID, this.logoImage));
                }
            }
            await $q.all(requests);
            await this.fetchFormData();
            this.notificationService.showSuccessMessage();
        } catch (e) {
            this.notificationService.showErrorMessage(e);
        } finally {
            this.waiting = false;
        }
    }

    public isFormValid(): boolean {
        return this.businessName && this.form.CompanyName.$valid;
    }

    private async fetchFormData() {
        const stores = await this.publisherSettingsService.getStores();
        if (stores && stores[0]) {
            this.originalStore = stores[0];
            this.businessName = stores[0].Name;
            this.logoImage = stores[0].IconID ? this.retailerService.getStoreLogoUrl(stores[0].IconID, 124, 124) : null;
        }
        this.imageChanged = false;
        this.form.$setPristine();
    }
}

angular.module('naut').component('publisherSettings', {
    template: require('./publisher-settings.component.html'),
    controller: PublisherSettingsComponent,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/publisher-settings/publisher-settings.component.ts